<div class="flex--row print-border-all table-header">
  <div
    class="flex__child flex__child-3 table-header print-padding align-desktop-top align-print-center"
  >
    {{ title }}
  </div>
  <div
    class="flex__child flex__child-1 table-header text--center text--bold print-padding-vertical align-desktop-top align-print-center"
  >
    {{ 'hectares' | translate }}
  </div>
  <div class="flex__child flex__child-4">
    <div class="flex--row">
      <div class="flex__child flex__child-1 table-header text--center text--bold print-border-left">
        <div class="print-border-bottom print-padding-vertical">
          {{ 'nFertilizer' | translate }}
        </div>
        <div class="flex--row flex--nowrap">
          <div class="flex__child flex__child-1 text--center text--label print-padding">
            {{ 'standard' | translate }}
          </div>
        </div>
      </div>
      <div class="flex__child flex__child-1 table-header text--center text--bold print-border-left">
        <div class="print-border-bottom print-padding-vertical">
          {{ 'phosphate' | translate }}
        </div>
        <div class="flex--row flex--nowrap">
          <div class="flex__child flex__child-1 text--center text--label print-padding">
            {{ 'standard' | translate }}
          </div>
        </div>
      </div>
      <div class="flex__child flex__child-1 table-header text--center text--bold print-border-left">
        <div class="print-border-bottom print-padding-vertical">
          {{ 'nTotal' | translate }}
        </div>
        <div class="flex--row flex--nowrap">
          <div class="flex__child flex__child-1 text--center text--label print-padding">
            {{ 'standard' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
@for (cropField of cropFields; track cropField) {
  <div
    class="flex--row print-border-no-top avoid-page-break"
    data-test="fertilization-legal-standards-cropField"
  >
    <div
      class="flex__child flex__child-3 flex print-padding-horizontal align-desktop-top align-print-center"
      data-test="fertilization-legal-standards-cropField__name"
    >
      {{ cropField.cropFieldName }}, {{ cropField.cropName }}
      @if (cropField?.cropVarietyName) {
        <span>&nbsp;({{ cropField?.cropVarietyName }})</span>
      }
      @if (getGrasslandUsageTranslationKey(cropField.grasslandUsage); as grasslandUsage) {
        <span>:&nbsp;{{ grasslandUsage | translate }}</span>
      }
      @if (cropField?.isPerennialCultivation) {
        <span>&nbsp;-&nbsp;{{ 'perennialCultivation' | translate }}</span>
      }
      @if (cropField?.nitrogenCalculationSettings?.isAfterTornGrass) {
        <span>&nbsp;({{ 'fields.afterTornGrassShort' | translate }})</span>
      }
    </div>
    <div
      class="flex__child flex__child-1 text--center align-desktop-top align-print-center"
      data-test="fertilization-legal-standards-cropField__hectares"
    >
      {{ cropField.areaInHectares | agrNumber: '1.2-2' }}
    </div>
    <div class="flex__child flex__child-4">
      <div class="flex--row full-height">
        <div class="flex__child flex__child-1 flex--row text--center print-border-left">
          <div
            class="flex__child flex__child-1 text--center print-padding"
            data-test="fertilization-legal-standards-cropField__nManureLegalStandard"
          >
            {{ cropField.nManureLegalStandard | agrNumber: '1.0-0' }}
          </div>
        </div>
        <div class="flex__child flex__child-1 flex--row text--center print-border-left">
          <div
            class="flex__child flex__child-1 text--center print-padding"
            data-test="fertilization-legal-standards-cropField__p2O5LegalStandard"
          >
            {{ cropField.p2O5LegalStandard | agrNumber: '1.0-0' }}
          </div>
        </div>
        <div class="flex__child flex__child-1 flex--row text--center print-border-left">
          <div
            class="flex__child flex__child-1 text--center print-padding"
            data-test="fertilization-legal-standards-cropField__nTotalLegalStandard"
          >
            {{ cropField.nTotalLegalStandard | agrNumber: '1.0-0' }}
          </div>
        </div>
      </div>
    </div>
  </div>
}
